import { useEffect } from 'react'
import { useLocation } from 'react-router-dom'

/**
 * Helper hook to update document title, meta description and og/twitter meta tags dynamically.
 */
export function useDocumentMeta({ title, description, image, canonical }) {
  const location = useLocation()

  useEffect(() => {
    // 1. Update Title
    if (title) {
      document.title = title
    }

    // 2. Helper to set or update meta tag
    const setMetaTag = (attributeName, attributeValue, content) => {
      if (!content) return
      let el = document.querySelector(`meta[${attributeName}="${attributeValue}"]`)
      if (!el) {
        el = document.createElement('meta')
        el.setAttribute(attributeName, attributeValue)
        document.head.appendChild(el)
      }
      el.setAttribute('content', content)
    }

    // 3. Meta description
    if (description) {
      setMetaTag('name', 'description', description)
      setMetaTag('property', 'og:description', description)
      setMetaTag('name', 'twitter:description', description)
    }

    // 4. Open Graph & Twitter Title
    if (title) {
      setMetaTag('property', 'og:title', title)
      setMetaTag('name', 'twitter:title', title)
    }

    // 5. Open Graph & Twitter Image
    if (image) {
      setMetaTag('property', 'og:image', image)
      setMetaTag('name', 'twitter:image', image)
    }

    // 6. OG URL & Canonical
    const currentUrl = canonical || window.location.href
    setMetaTag('property', 'og:url', currentUrl)
    setMetaTag('property', 'og:type', 'website')
    setMetaTag('name', 'twitter:card', 'summary_large_image')

    let canonicalEl = document.querySelector('link[rel="canonical"]')
    if (!canonicalEl) {
      canonicalEl = document.createElement('link')
      canonicalEl.setAttribute('rel', 'canonical')
      document.head.appendChild(canonicalEl)
    }
    canonicalEl.setAttribute('href', currentUrl)
  }, [title, description, image, canonical, location.pathname])
}
